type CoReleaseCreditProps = {
  className?: string;
};

export function CoReleaseCredit({ className = 'doc-body' }: CoReleaseCreditProps) {
  return (
    <p className={className}>
      Co-released with{' '}
      <a
        href="https://www.selvajariarecords.com/"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Selvajaria Records
      </a>{' '}
      and Vortex Records under an agreement nobody remembers signing.
    </p>
  );
}
